import * as React from 'react';
import { root } from '@estee/elc-universal-utils';

export interface IState {
    translations: object;
}

export interface ITranslationUrl {
    url: string;
    title: string;
    options: { absolute: boolean; new_window: boolean };
}

export interface IProps {
    translations: { [k: string]: string };
}

export interface ITranslationsCollection {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export interface ITranslationsCollections {
    [key: string]: ITranslationsCollection;
}

export function translate<ComponentProps>(translationFields: string[]) {
    if (root.registerTranslationFieldsToPreload) {
        root.registerTranslationFieldsToPreload(translationFields);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent: any): any => {
        return class extends React.Component<ComponentProps, IState> {
            static displayName = 'translate';
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            constructor(props: any) {
                super(props);

                const translationsFromCache = root.getPreloadedTranslations
                    ? root.getPreloadedTranslations(translationFields)
                    : null;

                const translations: ITranslationsCollection = props.translations
                    ? props.translations
                    : translationsFromCache;

                this.state = {
                    translations
                };
            }

            public async componentDidMount() {
                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const componentRenderer = root.ComponentRenderer as any;
                // App could not be using component renderer
                const preloader = componentRenderer ? componentRenderer.preloader : null;

                if (!this.state.translations) {
                    let translations = null;

                    if (preloader && preloader.preload) {
                        await preloader.preload();
                        translations = preloader.getPreloadedTranslations(translationFields);
                    } else {
                        const { GlobalServiceBus, ServiceBusTopics, addTranslations } = root;

                        translations = await GlobalServiceBus.query(
                            ServiceBusTopics.queries.GET_TRANSLATIONS,
                            translationFields
                        );

                        if (addTranslations) {
                            addTranslations(translations);
                        }
                    }
                    if (translations) {
                        this.setState({
                            translations
                        });
                    }
                }
            }

            public render() {
                if (!this.state.translations) {
                    return null;
                }

                return <WrappedComponent {...this.props} translations={this.state.translations} />;
            }
        };
    };
}

export function mockTranslate<ComponentProps>(translationFields: string[]) {
    const translations: ITranslationsCollection = {};

    translationFields.forEach(field => {
        translations[field] = field;
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent: any): any => {
        return class extends React.Component<ComponentProps, IState> {
            public render() {
                return <WrappedComponent translations={translations} {...this.props} />;
            }
        };
    };
}
